import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function readMore() {
    const reads = document.querySelectorAll('.read_more');

    if (reads.length == 0) return;

    let text = [];
    let currentEl;
    let nextEl;

    reads.forEach((el, index) => {
        currentEl = el.parentElement?.nextElementSibling;
        text[index] = '';

        let isTimeline = el.parentElement?.classList.contains('timeline');

        if (isTimeline) {
            currentEl = el.nextElementSibling;
        }

        do {
            if (!currentEl) currentEl = nextEl;
            currentEl.classList.add('read_more_text');
            text[index] += currentEl.outerHTML;
            nextEl = currentEl.nextElementSibling;
            currentEl.remove();
            currentEl = undefined;
        } while (!nextEl.classList.contains('end_of_read'));

        nextEl.remove();

        el.addEventListener('click', function (e) {
            e.preventDefault();
            console.log(el);
            if (el.classList.contains('read_less')) {
                el.classList.remove('read_less');
                el.innerHTML = '<a class="button">Read more</a>';
                if (isTimeline) {
                    let elem = document.querySelector('.read_more_text');
                    while (elem.nextElementSibling && !elem.nextElementSibling.classList.contains('read_more')) {
                        elem.nextElementSibling.remove();
                    }
                    elem.remove();
                    ScrollUtil.scrollToTarget(el, -200, 200);
                } else {
                    el.parentElement.outerHTML = text[index];
                }
                return;
            }
            if (isTimeline) {
                // el.insertAdjacentHTML('afterend', '<p class="read_less_marker"></p>');
                el.insertAdjacentHTML('beforebegin', text[index]);
                el.classList.add('read_less');
                el.innerHTML = '<a class="button">Read less</a>';
                console.log(el);
                // el.remove();
            } else {
                el.parentElement.outerHTML = text[index];
            }
        });
    });
}

onDomReady(() => {
    readMore();
});
